import React, { useState, useEffect } from "react"

import Tooltip from "../Tooltip/"
import "./MapRenderer.scss"

export default function MapRenderer(props) {
  const { width, height, translate, scale } = props
  const [hoveredCountry, setHoveredCountry] = useState(null)
  const hoverCountry = (country) => {
    return (event) => {
      if (!props.tooltipEnabled) {
        return
      }
      if (!country) {
        setHoveredCountry(country)
        return
      }
      let x = 0
      let y = 0
      if ("pageX" in event) {
        x = event.pageX
        y = event.pageY
      }
      if (event.touches) {
        event.preventDefault()
        event.stopPropagation()
        if (props.tooltipMessage == null) {
          props.gotoCountryPage(country.info.name)()
          return
        }
      }
      if (country.data) {
        const countryData = country.data.originalDatum || country.data
        const scoreKey = country.data.scoreKey || "overall"
        setHoveredCountry({ country: countryData, x, y, scoreKey })
      } else {
      }
    }
  }

  useEffect(() => {
    const hideTooltip = () => setHoveredCountry(null)
    window.addEventListener("scroll", hideTooltip)
    return function cleanup() {
      window.removeEventListener("scroll", hideTooltip)
    }
  }, [])

  return (
    <svg
      className="MapRenderer"
      style={{ overflow: props.overflow ? "visible" : null }}
      width={width}
      height={height}
    >
      <g transform={`translate(${translate}) scale(${scale})`}>
        {props.countryOpacity > 0 ? (
          <g opacity={props.countryOpacity - props.pointOpacity * 0.7}>
            {props.paths
              .sort((a, b) => {
                return props.strokedCountries.length
                  ? (props.strokedCountries.includes(a.id) ? 1 : -1) -
                      (props.strokedCountries.includes(b.id) ? 1 : -1)
                  : 0
              })
              .map((c) => {
                const customStroke = props.strokedCountries.includes(c.id)
                const stroke = customStroke
                  ? props.customStroke.color
                  : props.defaultStroke
                const strokeWidth = customStroke
                  ? props.customStroke.width
                  : props.defaultStrokeWidth
                const fill = props.colorByData
                  ? props.colorByPercentDifferenceData
                    ? c.percentDifferenceColor
                    : c.color
                  : props.defaultFill
                const active =
                  c.info &&
                  !(
                    props.colorByPercentDifferenceData &&
                    c.percentDifferenceColor === "rgb(51, 51, 51)"
                  )
                const onClick = active
                  ? props.gotoCountryPage(c.info.name)
                  : () => {}
                const opacity = c.data.opacity ? c.data.opacity : null
                return (
                  <path
                    key={`country-${c.id}`}
                    opacity={opacity}
                    d={c.paths[props.id]}
                    strokeWidth={strokeWidth / scale}
                    stroke={stroke}
                    fill={fill}
                    className={active ? null : "noData"}
                    data-country-name={c.id}
                    onClick={onClick}
                    onMouseOver={hoverCountry(c)}
                    onMouseMove={hoverCountry(c)}
                    onMouseOut={hoverCountry(null)}
                    onTouchEnd={hoverCountry(c)}
                  />
                )
              })}
          </g>
        ) : null}
        {props.labelOpacity > 0 ? (
          <g opacity={props.labelOpacity}>
            {props.paths
              .filter((c) => props.selectedLabels.includes(c.id) && c.info)
              .map((c) => {
                const line3Label = props.showPercentDifferenceLabel
                  ? `${
                      c.overall_percentDifference > 0 ? "+" : ""
                    }${c.overall_percentDifference.toFixed(2)}%`
                  : `${c.rank} / ${c.count}`
                return (
                  <g
                    key={`label-${c.id}`}
                    className="label"
                    transform={`translate(${c.center.x}, ${c.center.y}) scale(${
                      1 / scale || 1
                    })`}
                  >
                    <text y={-20}>{c.value.toFixed(2)}</text>
                    <text>{c.info.name.toUpperCase()}</text>
                    <text y={20}>{line3Label}</text>
                  </g>
                )
              })}
          </g>
        ) : null}
      </g>
      {hoveredCountry ? (
        <Tooltip
          {...hoveredCountry}
          tooltipMessage={props.tooltipMessage}
          closeTooltip={hoverCountry(null)}
          gotoDetails={props.gotoCountryPage(hoveredCountry.country.Country)}
          colorByPercentDifferenceData={props.colorByPercentDifferenceData}
          selectedYear={props.selectedYear}
        />
      ) : null}
    </svg>
  )
}

MapRenderer.defaultProps = {
  width: 1280,
  height: 640,
  translate: [640, 320],
  scale: 1,
  tooltipEnabled: false,
  countryOpacity: 0,
  pointOpacity: 0,
  labelOpacity: 0,
  paths: [],
  selectedLabels: [],
  strokedCountries: [],
  customStroke: { color: "#333", width: 1 },
  defaultStroke: "white",
  defaultStrokeWidth: 0.5,
  colorByData: false,
  defaultFill: "#ffffff",
  tooltipMessage: "",
  gotoCountryPage: () => {},
  showPercentDifferenceLabel: false,
}
